<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="tempo_ign_off" class="col-sm-2 control-label">TEMPO PARADO (seg):</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.tempo_ign_off" class="form-control input-sm" id="tempo_ign_off">
            </div>
            <label for="tempo_ign_on" class="col-sm-2 control-label">TEMPO DIRIGINDO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_ign_on"  class="form-control" id="tempo_ign_on" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import { Bus } from '../../../../class/bus';
    import { Vitana } from '../../../../class/vitana';
    export default {
        name: "TemposVitana",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Vitana.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
